import { gql } from '@apollo/client';

export const CREATE_USER = gql`
  mutation createUser(
    $name: String
    $email: String!
    $lastName: String
    $password: String
    $companyId: String
    $roles: [Roles!]!
    $inviteSubUser: Boolean
    $country: Country
  ) {
    createUser(
      input: {
        name: $name
        email: $email
        lastName: $lastName
        password: $password
        roles: $roles
        companyId: $companyId
        inviteSubUser: $inviteSubUser
        country: $country
      }
    ) {
      email
      id
      role
      roles
    }
  }
`;

export const CREATE_USER_ON_COMPANY = gql`
  mutation createUser(
    $name: String
    $email: String!
    $lastName: String
    $password: String
    $companyId: String
    $roles: [Roles!]!
  ) {
    createUser(
      input: {
        name: $name
        email: $email
        lastName: $lastName
        password: $password
        companyId: $companyId
        inviteSubUser: true
        roles: $roles
      }
    ) {
      email
      id
      role
      roles
    }
  }
`;

export const DELETE_USER = gql`
  mutation deleteUser($email: String!) {
    deleteUser(userId: $email)
  }
`;

export const SEND_INVITE = gql`
  mutation sendInvite($email: String!) {
    createInviteUserRequest(input: { email: $email }) {
      id
      email
      invitationReSent
    }
  }
`;
